import { RefObject, useEffect, useRef, useState } from "react";
import CostPie from "./CostPie";
import TimePie from "./TimePie";
import { IAnalyticsData } from "../types";
import { MonthNumber } from "../../../constants/MonthNumber";
import { useTranslation } from "react-i18next";

interface IAnalyticsItem {
	data: IAnalyticsData
	is: "projects" | "employees" | "categories"
	onExport: (time: RefObject<HTMLDivElement>, cost: RefObject<HTMLDivElement>) => void
}

export default function AnalyticsItem({ data, is, onExport } : IAnalyticsItem) {

	const [isActive, setIsActive] = useState(true),
	[isHide, setIsHide] = useState(false),
	timeout = useRef<ReturnType<typeof setTimeout> | null>(null),
	costImage = useRef<HTMLDivElement>(null),
	timeImage = useRef<HTMLDivElement>(null),
	{ t } = useTranslation();

	useEffect(() => {
		setIsHide(true);
		if(isActive) {
			timeout.current = setTimeout(() => {
				setIsHide(false);
			},500)
		}
	}, [isActive])

	return (
		<div className={`analytics-item${isActive ? " is-active" : ""}${isHide ? " is-hide" : ""}`}>
			<div className="analytics-item__header">
				<button className="analytics-item__target" onClick={() => {if(isHide) setIsActive(true); else if(!isHide) setIsActive(false)}} aria-label={data.name}></button>
				<div className="analytics-item__header-col">
					<h3 className="analytics-item__title">
						{data.name}
					</h3>
					<div className="analytics-item__date">{MonthNumber()[data.start_month].translate}, {data.start_year} - {MonthNumber()[data.end_month].translate}, {data.end_year}</div>
				</div>
				<div className="analytics-item__header-col">
					<button className="analytics-item__export btn is-grey is-min is-transparent visible-on-desktop" onClick={() => onExport(timeImage, costImage)} aria-label={t("employees_admin.table.export")} type="button">
						<span>{t("employees_admin.table.export")}</span>
						<svg width="24" height="24">
							<use href="#download"></use>
						</svg>
					</button>
					<div className="analytics-item__arrow">
						<svg width="10" height="7">
							<use href="#drop-down-arrow"></use>
						</svg>
					</div>
				</div>
			</div>
			<div className="analytics-item__content">
				<div>
					{is !== "categories" && (
						<>
							<TimePie data={data.time_statistics} pieRef={timeImage} is={is} />
							<CostPie data={data.cost_statistics} pieRef={costImage} is={is} />	
						</>
					)}
					<button className="analytics-item__export btn is-grey is-min is-transparent visible-on-mob" onClick={() => onExport(timeImage, costImage)} type="button" aria-label={t("employees_admin.table.export")}>
						<span>{t("employees_admin.table.export")}</span>
						<svg width="24" height="24">
							<use href="#download"></use>
						</svg>
					</button>
				</div>
			</div>
		</div>
	)
}